// AI: the answer shown while the customer types.

import React from 'react';
import { I } from '../../../common/v5/config';
import { textIn } from './definition';
import { Section, Switch } from './ui';

export default function AiTab({ defn, lang, onChange }) {
	const off = defn.case_types.filter(c => !c.ai_enabled);
	return (
		<div className="aif-stack">
			<Section title={I("AI answers")} hint={I("When the description is long enough, the form looks for an answer in the library of the case type's area and shows it above Send.")}>
				<Switch
					checked={defn.ai.enabled}
					onChange={enabled => onChange(Object.assign({}, defn, { ai: Object.assign({}, defn.ai, { enabled }) }))}
					label={I("Show AI answers on this form")}
					description={I("Customers can still send their question; the answer they saw is added to the errand as an internal note.")}
				/>
				{off.length > 0 && defn.ai.enabled && (
					<p className="aif-muted aif-small">
						{I("Off for:")} {off.map(c => textIn(c.label, lang, defn.default_language) || c.key).join(", ")} {I("(change it under Case types).")}
					</p>
				)}
			</Section>

			<Section title={I("Where answers come from")}>
				<ul className="aif-muted" style={{ margin: 0, paddingLeft: 0, listStyle: "none" }}>
					<li style={{ display: "flex", gap: 8 }}>
						<i className="fa fa-book" style={{ color: "#0c87f7", marginTop: 2 }} aria-hidden="true" />
						<span>{I("The library of the area each case type routes to.")}</span>
					</li>
					<li style={{ display: "flex", gap: 8, marginTop: 6 }}>
						<i className="fa fa-magic" style={{ color: "#0c87f7", marginTop: 2 }} aria-hidden="true" />
						<span>{I("The answer is written only from those library texts and lists them as sources. When nothing fits, no answer is shown.")}</span>
					</li>
					<li style={{ display: "flex", gap: 8, marginTop: 6 }}>
						<i className="fa fa-flask" style={{ color: "#0c87f7", marginTop: 2 }} aria-hidden="true" />
						<span>{I("Try a question in the preview on the right once the form is published.")}</span>
					</li>
				</ul>
			</Section>
		</div>
	);
}
